<template>
  <div class="page-content-container">
    <div class="container-1000">
      <div class="page-content-header">
        <div class="page-title">老师招募</div>
        <div class="page-subtitle">
          您还不是「极客 · 服务中心」的老师，期待你的加入！
        </div>
        <el-steps
          :active="latestInfo.apply_status"
          align-center
          class="page-steps"
        >
          <el-step title="提交申请"></el-step>
          <el-step title="等待审核"></el-step>
          <el-step
            :title="latestInfo.apply_status !== 3 ? '开始工作' : '重新申请'"
          ></el-step>
        </el-steps>
      </div>
      <div class="page-content-body" v-loading="loading">
        <!-- 未申请 -->
        <div v-if="latestInfo.apply_status === 0" class="section-form">
          <div class="section-title">申请表单</div>
          <el-form
            :model="applyInfo"
            :rules="applyRules"
            ref="applyInfo"
            label-width="120px"
            class="apply-info"
          >
            <el-form-item label="真实姓名：" prop="name" :show-message="false">
              <el-input
                class="w-300"
                v-model.trim="applyInfo.name"
                placeholder="请输入真实姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email" :show-message="false">
              <el-input
                class="w-300"
                v-model="applyInfo.email"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="学历："
              prop="qualification"
              :show-message="false"
            >
              <el-select
                class="w-300"
                v-model="applyInfo.qualification"
                clearable
                placeholder="请选择学历"
              >
                <el-option
                  v-for="item in constData.qualifications"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="毕业院校："
              prop="college"
              :show-message="false"
            >
              <el-input
                class="w-300"
                v-model="applyInfo.college"
                placeholder="请输入毕业院校"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="初次工作时间："
              prop="job_started_at"
              :show-message="false"
            >
              <el-date-picker
                class="w-300"
                v-model="applyInfo.job_started_at"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="请选择初次工作时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="工作职位："
              prop="position"
              :show-message="false"
            >
              <el-select
                class="w-300"
                v-model="applyInfo.position"
                clearable
                placeholder="请选择工作职位"
              >
                <el-option
                  v-for="item in constData.positions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="公司类型："
              prop="company_type"
              :show-message="false"
            >
              <el-select
                class="w-300"
                v-model="applyInfo.company_type"
                clearable
                placeholder="请选择公司类型"
              >
                <el-option
                  v-for="item in constData.company_types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="公司简称："
              prop="company_name"
              :show-message="false"
            >
              <el-input
                class="w-300"
                v-model="applyInfo.company_name"
                placeholder="请输入公司简称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="岗位方向："
              prop="jobIds"
              :show-message="false"
            >
              <!-- <el-select
                class="w-300"
                v-model="applyInfo.jobIds"
                clearable
                multiple
                placeholder="请选择岗位方向"
              >
                <el-option
                  v-for="item in constData.jobs"
                  :key="item.value"
                  :label="item.label.short_name"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
              <CascaderPosition
                :jobs.sync="jobs"
                :value.sync="applyInfo.jobIds"
                :multiple="true"
                @getNodes="handleSelectPost"
              ></CascaderPosition>
            </el-form-item>
            <el-form-item
              label="申请角色："
              prop="apply_roles"
              :show-message="false"
            >
              <el-select
                class="w-300"
                v-model="applyInfo.apply_roles"
                clearable
                multiple
                placeholder="请选择申请角色"
              >
                <el-option
                  v-for="item in constData.apply_roles"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="补充信息：">
              <el-input
                class="w-300"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="请在这里填写其他相关信息，比如申请理由、过往经验等"
                clearable
                v-model.trim="applyInfo.direction"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="简历：">
              <el-upload
                class="w-300 upload-demo"
                ref="upload"
                action=""
                :limit="1"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-preview="handleOnPreview"
                :on-remove="handleBeforeRemove"
                accept="application/pdf"
              >
                <el-button
                  slot="trigger"
                  :loading="btnLoading"
                  plain
                  type="primary"
                  >选取文件</el-button
                >
                <span slot="tip" class="el-upload__tip ml-12">
                  只能上传 pdf 格式文件
                </span>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="btn-container">
            <zhu-button
              class="apply-btn mt-12"
              text="申请成为老师"
              :shadow="true"
              size="defalut"
              type="primary"
              :loading="btnLoading"
              @click="handleApply"
            >
            </zhu-button>
          </div>
        </div>

        <!-- 已申请 -->
        <div v-if="latestInfo.apply_status !== 0" class="section-status">
          <div class="section-title">最近申请</div>
          <el-alert
            v-if="!authPermissions.length && latestInfo.apply_status === 2"
            class="mb-12"
            title="恭喜你通过审核，请耐心等待管理人员添加权限"
            type="info"
          >
          </el-alert>
          <el-alert
            v-if="!authPermissions.length && latestInfo.apply_status === 3"
            class="mb-12"
            title="您的审核已被拒绝，请重新填写申请表单"
            type="info"
          >
          </el-alert>
          <el-card class="status-card">
            <el-tag class="status-tag">{{
              latestInfo.apply_status_label
            }}</el-tag>
            <div class="card-item">
              <span class="item-title">申请时间：</span>
              <span class="item-text">{{ latestInfo.created_at }}</span>
            </div>
            <div class="card-item">
              <span class="item-title">申请角色：</span>
              <span class="item-text">{{ latestInfo.apply_roles_name }}</span>
            </div>
            <div class="card-item" v-if="latestInfo.resume">
              <span class="item-title">申请简历：</span>
              <a
                class="item-text item-link"
                :href="latestInfo.resume.path"
                target="_blank"
                >{{ latestInfo.resume.name }}</a
              >
            </div>
            <div class="card-item" v-if="latestInfo.handle_result">
              <span class="item-title">拒绝理由：</span>
              <span class="item-text">{{ latestInfo.handle_result }}</span>
            </div>
          </el-card>
          <div class="btn-container">
            <zhu-button
              class="apply-btn"
              text="申请成为老师"
              :shadow="true"
              size="defalut"
              type="primary"
              :disabled="
                latestInfo.apply_status === 1 || latestInfo.apply_status === 2
              "
              @click="handleReapply"
            >
            </zhu-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qiniuService from "@/global/service/qiniu";
import expertService from "@/global/service/expert";
import CascaderPosition from "./widgets/CascaderPosition";
import API from "@/global/request/api";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      btnLoading: false,
      constData: {
        industryJob: []
      },
      fileList: [],
      jobs: [],
      applyInfo: {
        name: "",
        email: "",
        qualification: null,
        college: null,
        job_started_at: null,
        position: null,
        company_name: "",
        jobIds: [],
        apply_roles: [],
        resume_id: null,
        direction: "",
        platform_type: 1,
        jobs: []
      },
      latestInfo: {
        apply_status: null,
        apply_status_label: "",
        apply_created_at: "",
        apply_roles: [],
        resume: {
          id: 12,
          path: "",
          name: "简历"
        }
      },
      applyRules: {
        name: { required: true, trigger: "blur" },
        email: [
          { required: true, trigger: "blur" },
          {
            type: "email",
            trigger: ["blur", "change"]
          }
        ],
        qualification: { required: true, trigger: "change" },
        college: { required: true, trigger: "change" },
        job_started_at: {
          required: true,
          trigger: "change",
          message: "初次工作时间"
        },
        position: { required: true, trigger: "change" },
        company_type: {
          required: true,
          trigger: "change",
          message: "公司类型"
        },
        company_name: { required: true, trigger: "blur" },
        jobIds: {
          required: true,
          message: "请选择活动区域",
          trigger: "change"
        },
        apply_roles: { required: true, trigger: "change" }
      }
    };
  },
  components: {
    CascaderPosition
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  methods: {
    getData() {
      this.loading = true;
      expertService
        .expectLatest()
        .then(res => {
          const latestInfo = res
            ? res
            : {
                apply_status: 0 //0-未申请，1-待审核,2-通过，3-拒绝
              };
          this.getConst(latestInfo);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getConst(latestInfo) {
      expertService
        .expertConst()
        .then(constData => {
          let result = [];
          if (latestInfo && latestInfo.apply_roles) {
            constData.apply_roles.forEach(role => {
              latestInfo.apply_roles.forEach(id => {
                if (role.value == id) {
                  result.push(role.label);
                }
              });
            });
          }
          latestInfo.apply_roles_name = result.join("、");
          this.latestInfo = latestInfo;
          this.constData = constData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleBeforeUpload(file) {
      if (!file || !this.validateSize(file)) {
        return false;
      }
      const space = "_for_expert_sub_project";
      const folder = "fuwu";
      const api = API.expertFile;
      this.btnLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          this.fileList = [{ name: res.name, url: res.path }];
          this.applyInfo.resume_id = res.id;
        })
        .finally(() => {
          this.btnLoading = false;
        });
      return false;
    },
    handleOnPreview(file) {
      window.open(file.url);
    },
    handleBeforeRemove(file) {
      if (file && file.status === "success") {
        this.fileList = [];
        this.applyInfo.resume_id = null;
      }
    },
    validateSize(file) {
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = /(pdf)/;
      if (!imageRegex.test(suffix)) {
        this.$message.error(`请上传格式为pdf的文件`);
        return false;
      }
      return true;
    },
    handleSelectPost(e) {
      this.applyInfo.jobs = e.map(data => {
        return (data = {
          id: data.data.id,
          name: data.data.name,
          short_name: data.data.short_name
        });
      });
    },
    handleApply() {
      if (this.btnLoading) return;
      this.$refs["applyInfo"].validate(val => {
        if (!val) {
          this.$message.error("必填项不能为空");
          return;
        }
        if (!this.applyInfo.jobIds) {
          this.$message.error("岗位方向不能为空");
          return;
        }
        this.btnLoading = true;
        expertService
          .expertCreate(this.applyInfo)
          .then(() => {
            this.$message.success("您已提交申请，请耐心等待审核");
            this.getData();
            this.latestInfo.apply_status = 1;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    handleReapply() {
      this.latestInfo.apply_status = 0;
      const jobIds = this.latestInfo.jobs.map(item => item.id);
      const applyInfo = this.latestInfo;
      applyInfo.jobIds = jobIds;
      applyInfo.resume_id = this.latestInfo.resume?.id;
      this.fileList = this.latestInfo.resume
        ? [
            {
              name: this.latestInfo.resume?.name,
              url: this.latestInfo.resume?.path
            }
          ]
        : [];
      this.applyInfo = applyInfo;
    }
  }
};
</script>
<style lang="less" scoped>
.container-1000 {
  width: 1000px;
  margin: 0 auto;
}
/deep/ .el-step.is-horizontal .el-step__line {
  top: 26px;
}
/deep/ .el-step__icon {
  width: 50px;
  height: 50px;
}

.page-content-container {
  background: #f5f5f5;
  padding-bottom: 80px;
  .page-content-header {
    height: 380px;
    padding-top: 80px;
    background-image: url("~@/assets/images/welcome/apply-bg.svg");
    background-size: 1440px 380px;
    background-position: center;
    background-repeat: no-repeat;
    .page-title {
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-size: 56px;
      font-weight: 600;
      color: #409eff;
    }
    .page-subtitle {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      color: #999999;
    }
    .page-steps {
      width: 800px;
      margin: 40px auto 0;
    }
  }
  .page-content-body {
    min-height: 500px;
    .section-title {
      height: 33px;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 50px;
    }
    .btn-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .section-form {
      margin: 0 auto;
      padding: 60px 200px;
      background: #fff;
      .apply-info {
        width: 100%;
        padding: 40px;
        margin-bottom: 40px;
        border: 1px solid #ebeef5;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
    }
    .section-status {
      padding: 60px 200px;
      background: #fff;
      .status-card {
        position: relative;
        padding: 20px 10px;
        margin-bottom: 100px;
        .status-tag {
          position: absolute;
          right: 20px;
          top: 20px;
        }
        .card-item {
          font-size: 16px;
          margin-bottom: 12px;
          .item-title {
            color: #666;
            margin-right: 2px;
          }
          .item-text {
            color: #333;
            &.item-link {
              &:hover {
                color: #409eff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
